// extracted by mini-css-extract-plugin
export default {"wrapper":"CRMProductPage_wrapper__ZlkNL"};